module.exports = {
	// tag页标签-操作-中文的配置
	tagsView: {
		close: 'Close',
		closeOthers: 'Close Others',
		closeAll: 'Close All'
	},
	logpage: require('./logPage').en,

	// 系统设置
	stsytemset: require('./stsytemset').en,

	// tag-标签-
	route: require('./route').en.route,
	// 左侧菜单
	moduleIndexMenu: require('./moduleIndexMenu').en.moduleIndexMenu,
	// 职工管理
	staffManament: require('./staffManagement').en.staffManament,
	//家长管理
	parentsManagement: require('./parentsManagement').en,
	//报名招生
	enrollAndRecruit: require('./enrollAndRecruit').en,
	//连锁管理
	gardenManage: require('./gardenManage').en,
	//通知管理
	notificationManagement: require('./notificationManagement').en,
	studentManage: require('./studentManage').en,
	daily: require('./daily').en,
	attendance: require('./attendance').en,
	recipe: require('./recipe').en,
	paymentManagement: require('./paymentManagement').en,
	videoMonitoring: require('./videoMonitoring').en,
	courseManagement: require('./courseManagement').en,
	messageCenter: require('./messageCenter').en,
	// 官网新闻更新
	websiteNewsUpdate: require('./websiteNewsUpdate').en,
	qa: require('./QA').en,
}


// WEBPACK FOOTER //
// ./src/components/i18n/lang/en.js